<template>
	<span>
    <modal headline="Tilmeld dig ventelisten" :hideButton="true" :visible="visible" :buttons="modalButtons" @close="$emit('close')">
			<div class="mb-4">
				<participant-field label="Dit navn" v-model="userData.name" :required="true" :show-required-message="isMissing('name')" @blur="validate('name')" @keyup="validate('name', true)" @change="validate('name', true)" />
			</div>
			<div class="mb-4">
				<participant-field label="Din e-mail" v-model="userData.email" type="email" :required="true" :show-required-message="isMissing('email')" @blur="validate('email')" @keyup="validate('email', true)" @change="validate('email', true)" />
			</div>
			<participant-field label="Dit mobil tlf.nr." v-model="userData.phone" type="phone" :required="true" :show-required-message="isMissing('phone')" @blur="validate('phone')" @keyup="validate('phone', true)" @change="validate('phone', true)" />
		</modal>
		<modal headline="Du er nu tilmeldt ventelisten" :visible="thankYouVisible" @close="thankYouVisible = false">
			<p>Du vil høre fra os, hvis vi får en ledig plads på aktiviteten.</p>
		</modal>
	</span>
</template>

<script>
import ParticipantField from "./ParticipantField";

export default {
	components: {
		ParticipantField
	},
	props: {
		productId: String,
		visible: Boolean
	},
	data() {
		return {
			thankYouVisible: false,
			missingFields: [],
			userData: {
				name: "",
				email: "",
				phone: ""
			},
			modalButtons: [
				{
					action: () => {
						this.userData = {
							name: "",
							email: "",
							phone: ""
						};
						this.$emit('close');
					},
					text: "Annuller",
					class: "border-gray-300 bg-white text-black px-4 py-2 ml-4 mb-2 border"
				},
				{
					action: () => {
						if (this.isValidForSubmit)
						{
							this.addToWaitingList();
							this.$emit('close');
						}
					},
					text: "Tilmeld",
					class: "border-top bg-top text-top-text px-4 py-2 ml-4 mb-2 border"
				}
			]
		}
	},
	computed: {
		isValidForSubmit: function() {
			this.validate("name");
			this.validate("email");
			this.validate("phone");
			return this.missingFields.length == 0;
		}
	},
	methods: {
		isMissing: function(fieldName) {
			return this.missingFields.indexOf(fieldName) > -1;
		},
		validate: function(property, ifInvalid) {
			if (!ifInvalid || this.isMissing(property))
			{
				this.missingFields = this.missingFields.filter(f => f != property);
				var valid = this.userData[property] && this.userData[property] != "";

				if (!valid) {
					this.missingFields.push(property);
				}
			}
		},
		addToWaitingList: function() {

			if (this.isValidForSubmit) {
				this.$store
				.dispatch("addToWaitingList", {
					productId: this.productId,
					name: this.userData.name,
					email: this.userData.email,
					phone: this.userData.phone
				})
				.then(() => {
					this.$emit('close');
					this.thankYouVisible = true;
				});
			}
		}
	}
}
</script>
